import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

// Configuración de Firebase desde variables de entorno
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY || "AIzaSyDu6o8y37-goSR39VKEWXo9xA00641CjFA",
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || "tasco-d18f8.firebaseapp.com",
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || "tasco-d18f8",
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || "tasco-d18f8.firebasestorage.app",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || "536827396655",
  appId: process.env.VUE_APP_FIREBASE_APP_ID || "1:536827396655:web:f4fdb266c621cf8eec3cda",
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID || "G-6WSCTD53VS"
}

// Inicializar Firebase
const app = initializeApp(firebaseConfig)

// Inicializar Firebase Authentication
const auth = getAuth(app)

export { auth }
